var React = require('react');

function Genderless (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M144,336a80,80,0,1,1,80-80A80,80,0,0,1,144,336Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M144,112A144,144,0,1,0,288,256,144,144,0,0,0,144,112Zm0,224a80,80,0,1,1,80-80A80,80,0,0,1,144,336Z","className":"fa-primary","key":2})]);
}

Genderless.defaultProps = {"viewBox":"0 0 288 512","className":"icon"};

module.exports = Genderless;

Genderless.default = Genderless;
